import React from "react";
import { getMorningAndEveningCelebrations } from "./calendar/ordinariate-calendar";
import { LiturgyViewer } from "./liturgy/LiturgyViewer";
import { LiturgyItem } from "./liturgy/types";
import { TweakProvider } from "./utils/TweakProvider";
import { useSettings } from "./utils/settings";

export const OrdLitany: React.FC<{}> = () => {
    const year = getMorningAndEveningCelebrations(
        new Date().getFullYear(),
        false,
        false,
        false
    );

    const today = year.find(
        (day) =>
            day.date === new Date().getDate() &&
            day.month === new Date().getMonth() + 1 &&
            day.year === new Date().getFullYear()
    );

    if (!today) {
        throw new Error("Could not find today");
    }

    const { settings, setSetting } = useSettings();

    const liturgy: LiturgyItem[] = [
        {
            type: "rubric",
            content:
                "The Litany may be said or sung, kneeling, standing, or in procession, according to the occasion or circumstance. It may be used at the accustomed times. The Litany may also be said separately; especially in Advent and Lent, and on Rogation Days.",
        },
        {
            type: "rubric",
            content:
                "The Priest or Deacon (or cantor, if necessary) sings the Litany, with the People or Choir responding:",
        },
        {
            type: "minimal gabc chant",
            gabc: "(c3) O(h) God(h) the(h) Fa(h)ther,(h) Cre(h)a(h)tor(h) of(h) hea(h)ven(h) and(h) earth,(i) (::) *Have*(g) *mer*(g)*cy*(f) *u*(g)*pon*(h) *us.*(h) (::)",
            dropCap: true,
            tone: "",
        },
        {
            type: "minimal gabc chant",
            gabc: "(c3) O(h) God(h) the(h) Son,(h) Re(h)dee(h)mer(h) of(h) the(h) world,(i) (::) *Have*(g) *mer*(g)*cy*(f) *u*(g)*pon*(h) *us.*(h) (::)",
            dropCap: true,
            tone: "",
        },
        {
            type: "minimal gabc chant",
            gabc: "(c3) O(h) God(h) the(h) Ho(h)ly(h) Ghost,(h) Sanc(h)ti(h)fi(h)er(h) of(h) the(h) faith(i)ful,(g) (::) *Have*(g) *mer*(g)*cy*(f) *u*(g)*pon*(h) *us.*(h) (::)",
            dropCap: true,
            tone: "",
        },
        {
            type: "minimal gabc chant",
            gabc: "(c3) O(h) ho(h)ly,(h) bless(h)ed,(h) and(h) glo(h)rious(h) Tri(h)ni(h)ty,(h) three(h) Per(h)sons(h) and(h) one(h) God,(i) (::) *Have*(g) *mer*(g)*cy*(f) *u*(g)*pon*(h) *us.*(h) (::)",
            dropCap: true,
            tone: "",
        },
        {
            type: "minimal gabc chant",
            gabc: "(c3) Saint(h) Ma(h)ry,(h) Mo(h)ther(h) of(h) God(h) our(h) Lord(h) Je(h)sus(h) Christ,(i) (::) *Pray*(gf) *for*(g) *us.*(h) (::)",
            dropCap: true,
            tone: "",
        },
        {
            type: "minimal gabc chant",
            gabc: "(c3) All(h) ho(h)ly(h) An(h)gels(h) and(h) Arch(h)an(h)gels,(h) and(h) all(h) ho(h)ly(h) Or(h)ders(h) of(h) bless(h)ed(h) Spi(i)rits,(g) (::) *Pray*(gf) *for*(g) *us.*(h) (::)",
            dropCap: true,
            tone: "",
        },
        {
            type: "minimal gabc chant",
            gabc: "(c3) All(h) ho(h)ly(h) Pa(h)tri(h)archs(h) and(h) Pro(h)phets;(h) A(h)po(h)stles,(h) Mar(h)tyrs,(h) Con(h)fes(h)sors(h) and(h) Vir(h)gins;(h) and(h) the(h) bless(h)ed(h) Com(h)pa(h)ny(h) of(h) Hea(i)ven,(g) (::) *Pray*(gf) *for*(g) *us.*(h) (::)",
            dropCap: true,
            tone: "",
        },
    ];

    return (
        <TweakProvider initialState={{}}>
            <div
                style={{
                    textAlign: "center",
                    padding: 24,
                    paddingTop: 64,
                }}
            >
                <div
                    style={{
                        fontSize: "150%",
                        fontWeight: "bold",
                        lineHeight: 1.2,
                    }}
                >
                    The Litany
                </div>
            </div>
            <LiturgyViewer
                items={liturgy}
                label={"litany"}
                superTitle={""}
                title={"The Litany"}
            />
        </TweakProvider>
    );
};
